import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import { FormField } from '../../types';

interface CheckboxFieldInputProps {
  field: FormField;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CheckboxFieldInput: React.FC<CheckboxFieldInputProps> = ({ field, onChange }) => {
  return (
    <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
      <FormControlLabel
        control={<Checkbox required={field.required} />}
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={{ fontWeight: 500, color: '#000000' }}>
              {field.label || field.name}
            </Typography>
            {field.required && (
              <Typography sx={{ color: '#dc5456', fontWeight: 'bold' }}>*</Typography>
            )}
          </Box>
        }
        onChange={(e) => onChange(e as any)}
      />
    </Box>
  );
};

export default CheckboxFieldInput;
